/* Poster / included-Tag grouping. Legacy products retain one Tag per poster. */
(function (host, factory) {
  const core = factory();
  if (typeof module === 'object' && module.exports) module.exports = core;
  if (typeof window === 'undefined') return;
  const config=window.MPGelatoConfig;if(!config)return;
  const posterIds=new Set(config.posterVariantIds.map(Number));
  const artEntries = new Map();
  const artBlockedIds = new Set();
  let legacyEntries = new Map(), legacyFailure = false;
  try { legacyEntries = window.MPLegacyRoutingCore.normalizeRegistry(window.MPLegacyRouting); }
  catch { legacyFailure = true; }
  const root=window.Shopify?.routes?.root || '/';
  const defaultRoute = () => config.enabled ? 'gelato' : 'local-poster';
  const tagItem=(group,quantity,posterRoute=defaultRoute())=>({id:config.tagVariantId,quantity,properties:{_mp_group:group,_mp_role:'included-tag',_mp_route:'local-tag',[config.deliveryLabel||'Delivery']:posterRoute==='gelato'?(config.separateDelivery||'Ships separately'):(config.includedDelivery||'Included with your poster')}});
  function productionRoute(id) {
    try {
      const legacy = legacyEntries.get(Number(id));
      if (legacy) return window.MPLegacyRoutingCore.routeForVariant(legacy, config.country);
      if (legacyFailure && posterIds.has(Number(id))) throw new Error('LEGACY_ROUTING_UNCONFIRMED');
      if (artBlockedIds.has(Number(id))) throw new Error('ART_EXCLUDED_FROM_RELEASE');
      return core.routeForVariant(artEntries.get(Number(id)), config);
    }
    catch { throw new Error(config.routingError || config.error || 'This selection is unavailable. Remove it from your cart and choose another option.'); }
  }
  const isPoster=id=>posterIds.has(Number(id)) || legacyEntries.has(Number(id)) || artEntries.has(Number(id)) || artBlockedIds.has(Number(id));
  const getPosterUnits = id => artEntries.get(Number(id))?.posterUnits || (posterIds.has(Number(id)) || legacyEntries.has(Number(id)) ? 1 : 0);
  const getTagUnits = id => artEntries.get(Number(id))?.tagUnits || (posterIds.has(Number(id)) || legacyEntries.has(Number(id)) ? 1 : 0);
  // Every local poster already contains its Tag in the poster parcel.
  // Keep the included-unit count; only the separately shipped child is omitted.
  const getShipmentTagUnits = id => artEntries.get(Number(id))?.localOnly === true || legacyEntries.get(Number(id))?.route === 'local' ? 0 : getTagUnits(id);
  function registerArt(registry) {
    const entries = core.normalizeArtRegistry(registry);
    const blocked = core.normalizeArtBlockedIds(registry);
    for (const id of blocked) if (posterIds.has(id) || legacyEntries.has(id)) throw new Error('ART_REGISTRY_LEGACY_COLLISION');
    for (const [id, entry] of entries) {
      if (posterIds.has(id) || legacyEntries.has(id)) throw new Error('ART_REGISTRY_LEGACY_COLLISION');
      const current = artEntries.get(id);
      if (current && (current.posterUnits !== entry.posterUnits || current.tagUnits !== entry.tagUnits || ['framed','localOnly','foreignOnly','retired'].some(key => current[key] !== entry[key]))) throw new Error('ART_REGISTRY_CONFLICT');
    }
    for (const [id, entry] of entries) artEntries.set(id, Object.freeze({ ...entry }));
    for (const id of blocked) artBlockedIds.add(id);
    return entries.size;
  }
  function posterItems(id, quantity, properties = {}) {
    if (!isPoster(id)) throw new Error('UNKNOWN_POSTER_VARIANT');
    const group = crypto.randomUUID();
    const unitCounts = { posterUnits: getPosterUnits(id), tagUnits: getTagUnits(id) };
    const route = productionRoute(id);
    return core.makePairItems({ variantId: Number(id), quantity, group, unitCounts, properties, route, tag: tagItem(group, quantity * unitCounts.tagUnits, route), includePrintCount: artEntries.has(Number(id)), includeTag: getShipmentTagUnits(id) > 0 });
  }
  let running;
  async function request(endpoint,body){
    const r=await fetch(root+endpoint,{method:body?'POST':'GET',headers:{Accept:'application/json',...(body?{'Content-Type':'application/json'}:{})},...(body?{body:JSON.stringify(body)}:{})});
    const data=await r.json();if(!r.ok||data.status)throw new Error(data.description||config.error);return data;
  }
  async function normalize(){
    let cart=await request('cart.js');let changed=false;
    const photoIds=new Set(config.photoVariantIds||[]);
    for (const line of cart.items) {
      const legacy = legacyEntries.get(Number(line.variant_id));
      const photo = legacy?.photo === true || photoIds.has(Number(line.variant_id));
      if (!photo) continue;
      const route = productionRoute(line.variant_id);
      if (!line.properties?._mp_upload_id && !line.properties?._mp_print_url) throw new Error(config.photoError);
      if (route === 'gelato' && !line.properties?._mp_gelato_url) throw new Error(config.photoError);
    }
    // Validate the entire selection before writing anything. A retired format
    // or a foreign B0 line must be removed or explicitly replaced by the buyer.
    for (const line of cart.items) if (isPoster(line.variant_id)) productionRoute(line.variant_id);
    for(const line of cart.items){
      if(!isPoster(line.variant_id))continue;
      const properties={...line.properties,_mp_group:line.properties?._mp_group||crypto.randomUUID(),_mp_role:'poster',_mp_route:productionRoute(line.variant_id)};
      if(artEntries.has(Number(line.variant_id)))properties._mp_print_count=String(getPosterUnits(line.variant_id));
      if(Object.entries(properties).some(([key,value])=>line.properties?.[key]!==value)){
        await request('cart/change.js',{id:line.key,quantity:line.quantity,properties});changed=true;
      }
    }
    if(changed)cart=await request('cart.js');
    const groupRoutes=new Map();
    for(const line of cart.items){
      if(!isPoster(line.variant_id)||!line.properties?._mp_group)continue;
      const group=line.properties._mp_group,route=productionRoute(line.variant_id);
      if(!groupRoutes.has(group)||route==='gelato')groupRoutes.set(group,route);
    }
    // Reconcile quantities before normalizing properties. Shopify may merge
    // identical variant/property lines, changing their keys; remove duplicate
    // Tags first so later delivery-label updates target one stable parent group.
    const plan=core.planTagReconciliation(cart.items,config.tagVariantId,isPoster,getShipmentTagUnits);
    const updates=plan.updates,add=plan.add.map(item=>tagItem(item.group,item.quantity,groupRoutes.get(item.group)));
    if(Object.keys(updates).length){await request('cart/update.js',{updates});changed=true;}
    if(add.length){await request('cart/add.js',{items:add});changed=true;}
    if(Object.keys(updates).length||add.length)cart=await request('cart.js');
    // Existing Tags also receive the delivery wording for their parent's current
    // route, including a country switch or a framed DE/AT order.
    let tagsChanged=false;
    for(const line of cart.items){
      const group=line.properties?._mp_group;
      if(Number(line.variant_id)!==Number(config.tagVariantId)||!groupRoutes.has(group))continue;
      const properties={...line.properties};
      for(const label of ['Delivery','Lieferung','Entrega','Livraison','Consegna','Доставка'])delete properties[label];
      Object.assign(properties,tagItem(group,line.quantity,groupRoutes.get(group)).properties);
      if(Object.keys(properties).length!==Object.keys(line.properties||{}).length||Object.entries(properties).some(([key,value])=>line.properties?.[key]!==value)){
        await request('cart/change.js',{id:line.key,quantity:line.quantity,properties});tagsChanged=true;changed=true;
      }
    }
    if(tagsChanged)cart=await request('cart.js');
    if(changed && typeof publish==='function')publish(PUB_SUB_EVENTS.cartUpdate,{source:'mp-gelato'});
    return changed;
  }
  function reconcile(){if(!running)running=normalize().finally(()=>{running=null;});return running;}
  const publicApi={enabled:config.enabled,tagItem,isPoster,reconcile,registerArt,posterItems,getPosterUnits,getTagUnits,productionRoute};
  Object.defineProperties(publicApi,{
    posterUnitCounts:{get:()=>Object.freeze(Object.fromEntries([...posterIds].map(id=>[id,1]).concat([...legacyEntries].map(([id])=>[id,1]),[...artEntries].map(([id,entry])=>[id,entry.posterUnits]))))},
    tagUnitCounts:{get:()=>Object.freeze(Object.fromEntries([...posterIds].map(id=>[id,1]).concat([...legacyEntries].map(([id])=>[id,1]),[...artEntries].map(([id,entry])=>[id,entry.tagUnits]))))},
  });
  window.MPGelato=publicApi;
  if(window.MPArtRegistry){try{registerArt(window.MPArtRegistry);}catch(error){console.error('MagicPoster art registry:',error.message);}}
  // Reconcile separately shipped Tag children before checkout; local
  // posters include the Tag in their own parcel and need no physical child.
  document.addEventListener('click',async event=>{
    const checkout=event.target.closest('[name="checkout"],a[href*="/checkout"]');
    if(!checkout || checkout.dataset.mpReady==='true')return;
    event.preventDefault();event.stopImmediatePropagation();checkout.setAttribute('aria-busy','true');
    try{await reconcile();checkout.dataset.mpReady='true';checkout.click();}
    catch(error){window.alert(error.message||config.error);}
    finally{checkout.removeAttribute('aria-busy');}
  },true);
  document.addEventListener('submit',async event=>{
    const form=event.target,submitter=event.submitter;
    if(!(form instanceof HTMLFormElement)||!submitter||submitter.name!=='checkout'||form.dataset.mpReady==='true')return;
    event.preventDefault();event.stopImmediatePropagation();
    try{await reconcile();form.dataset.mpReady='true';form.requestSubmit(submitter);}
    catch(error){window.alert(error.message||config.error);}
  },true);
  if(config.cartCount>0)document.addEventListener('DOMContentLoaded',()=>reconcile().catch(()=>{}),{once:true});
})(typeof window === 'undefined' ? {} : window, function () {
  function normalizeArtRegistry(registry) {
    const result = new Map();
    if (!registry || registry.enabled !== true) return result;
    if (registry.schemaVersion !== 1 || registry.tagCountsConfirmed !== true || !registry.variants || Array.isArray(registry.variants)) throw new Error('ART_REGISTRY_UNCONFIRMED');
    for (const [rawId, entry] of Object.entries(registry.variants)) {
      const id = Number(rawId);
      if (!/^\d+$/.test(rawId) || String(id) !== rawId || !Number.isSafeInteger(id) || id <= 0 || !entry || ![1, 2].includes(entry.posterUnits) || ![1, 2].includes(entry.tagUnits)) throw new Error('ART_REGISTRY_INVALID');
      const normalized = { posterUnits: entry.posterUnits, tagUnits: entry.tagUnits };
      for (const key of ['framed', 'localOnly', 'foreignOnly', 'retired']) {
        if (entry[key] !== undefined) {
          if (typeof entry[key] !== 'boolean') throw new Error('ART_REGISTRY_INVALID');
          normalized[key] = entry[key];
        }
      }
      if (normalized.localOnly && normalized.foreignOnly) throw new Error('ART_REGISTRY_INVALID');
      result.set(id, normalized);
    }
    return result;
  }
  function routeForVariant(entry, config) {
    if (entry?.retired) throw new Error('RETIRED_ART_VARIANT');
    if (entry?.localOnly && !['DE','AT'].includes(config.country)) throw new Error('ART_COUNTRY_UNAVAILABLE');
    if (entry?.foreignOnly && (!config.country || ['DE','AT'].includes(config.country) || config.enabled !== true)) throw new Error('ART_COUNTRY_UNAVAILABLE');
    if (entry?.framed && !['DE','AT'].includes(config.country) && config.enabled !== true) throw new Error('ART_COUNTRY_UNAVAILABLE');
    return entry?.framed === true || config.enabled ? 'gelato' : 'local-poster';
  }
  function normalizeArtBlockedIds(registry) {
    const result=[];
    if (registry?.blockedVariantIds === undefined) return result;
    if (!Array.isArray(registry.blockedVariantIds)) throw new Error('ART_REGISTRY_INVALID');
    for (const raw of registry.blockedVariantIds) {
      const id=Number(raw);
      if (!/^\d+$/.test(String(raw)) || String(id)!==String(raw) || !Number.isSafeInteger(id) || id<=0 || registry.variants?.[String(id)] || result.includes(id)) throw new Error('ART_REGISTRY_INVALID');
      result.push(id);
    }
    return result;
  }
  function makePairItems({ variantId, quantity, group, unitCounts, properties, route, tag, includePrintCount, includeTag = true }) {
    if (!Number.isSafeInteger(quantity) || quantity < 1 || !unitCounts?.posterUnits || !unitCounts?.tagUnits || !Number.isSafeInteger(quantity * unitCounts.tagUnits)) throw new Error('INVALID_POSTER_QUANTITY');
    const posterProperties = { ...properties, _mp_group: group, _mp_role: 'poster', _mp_route: route };
    if (includePrintCount) posterProperties._mp_print_count = String(unitCounts.posterUnits);
    const items = [{ id: variantId, quantity, properties: posterProperties }];
    if (includeTag) items.push({ ...tag, quantity: quantity * unitCounts.tagUnits });
    return items;
  }
  function planTagReconciliation(items, tagVariantId, isPoster, tagUnitsFor) {
    const wanted = new Map();
    for (const line of items) {
      const group = line.properties?._mp_group;
      if (!group || !isPoster(line.variant_id)) continue;
      const units = tagUnitsFor(line.variant_id);
      if (!Number.isSafeInteger(units) || units < 0 || !Number.isSafeInteger(line.quantity) || line.quantity < 1) throw new Error('INVALID_TAG_PARENT');
      if (units === 0) continue;
      wanted.set(group, (wanted.get(group) || 0) + line.quantity * units);
    }
    const updates = {}, seen = new Set(), add = [];
    for (const line of items) {
      if (Number(line.variant_id) !== Number(tagVariantId)) continue;
      const group = line.properties?._mp_group;
      const quantity = group && !seen.has(group) ? wanted.get(group) || 0 : 0;
      if (quantity) seen.add(group);
      if (line.quantity !== quantity) updates[line.key] = quantity;
    }
    for (const [group, quantity] of wanted) if (!seen.has(group)) add.push({ group, quantity });
    return { updates, add };
  }
  return { normalizeArtRegistry, normalizeArtBlockedIds, routeForVariant, makePairItems, planTagReconciliation };
});
